import { widgetBusinessFetch } from "./business-fetch";
import { err, ok, type Result } from "neverthrow";
import { z } from "zod";
import {
  ordersPageResponseSchema,
  type OrdersPageResponse,
} from "@go-novus/admin-api";

export type OrderFailure =
  | "offline"
  | "rate_limited"
  | "needs_verification"
  | "not_accessible"
  | "upstream_unavailable";
const failure = z.enum([
  "rate_limited",
  "needs_verification",
  "not_accessible",
  "upstream_unavailable",
]);
export async function requestOrderPage(
  handshakeUrl: string,
  input: {
    uid: string;
    conversationId: string;
    liquidCustomerId?: string;
    ref: string;
    cursor: string;
  },
  fetchImpl: typeof fetch = widgetBusinessFetch(handshakeUrl),
): Promise<Result<OrdersPageResponse, OrderFailure>> {
  if (typeof navigator !== "undefined" && !navigator.onLine)
    return err("offline");
  try {
    const url = new URL(handshakeUrl, window.location.href);
    url.pathname = url.pathname.replace(/\/handshake$/, "/orders");
    const response = await fetchImpl(url.href, {
      method: "POST",
      credentials: "same-origin",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        uid: input.uid,
        conversation_id: input.conversationId,
        liquid_customer_id: input.liquidCustomerId,
        ref: input.ref,
        cursor: input.cursor,
      }),
      signal: AbortSignal.timeout(15_000),
    });
    const body: unknown = await response.json();
    if (!response.ok) {
      const parsed = z.object({ error: failure }).safeParse(body);
      return err(parsed.success ? parsed.data.error : "upstream_unavailable");
    }
    const parsed = ordersPageResponseSchema.safeParse(body);
    return parsed.success ? ok(parsed.data) : err("upstream_unavailable");
  } catch {
    return err("upstream_unavailable");
  }
}
